var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaySkipForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#FED241",
    strokeOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.25 18.25C27.25 17.5596 27.8096 17 28.5 17C29.1904 17 29.75 17.5596 29.75 18.25V27.75C29.75 28.4404 29.1904 29 28.5 29C27.8096 29 27.25 28.4404 27.25 27.75V18.25Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5386 23.7158C27.0924 23.3993 27.0924 22.6007 26.5386 22.2842L17.4834 17.1098C16.9338 16.7958 16.25 17.1926 16.25 17.8256V28.1744C16.25 28.8074 16.9338 29.2042 17.4834 28.8902L26.5386 23.7158Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaySkipForward);
export default __webpack_public_path__ + "static/media/play-skip-forward.b500fb79e4b864315b7c2f15b69d19d4.svg";
export { ForwardRef as ReactComponent };